<!-- login页面 code=110 照片重置，重新上传，审批没有通过 -->
<template>
    <div class="uploadTip">
        <div class="tipImgDiv">
            <img src="../IdentitAuthentication/images/btn_shibai_nor.png" alt="" class="tipImg">
        </div>
        <div class="tipTitle">审核未通过</div>
        <div class="tips">您上传的头像不符合规范，请重新上传 符合规范的证件照后进入系统。</div>
        <div class="gotoUploadBtn" @click="gotoUpload">前去上传</div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            drawer: false
        }
    },
    created() {

    },
    methods: {
        gotoUpload() {
            this.$router.push('/uploadUserPhoto')
        }
    }
}
</script>
<style scoped lang="less">
.uploadTip {
    position: relative;
    min-height: 100vh;

    .tipImgDiv {
        position: absolute;
        top: 10%;
        left: 50%;
        transform: translateX(-50%);
        width: 50%;
        height: 37.5vw;

        .tipImg {
            width: 100%;
            height: 100%;
        }
    }

    .tipTitle {
        position: absolute;
        top: 32%;
        left: 50%;
        transform: translateX(-50%);
        font-size: 1.5rem;
        font-weight: 400;
        color: #333333;
    }

    .tips {
        position: absolute;
        top: 40%;
        left: 50%;
        transform: translateX(-50%);
        font-weight: 400;
        width: 80%;
        text-indent: 2em;
        font-size: 1.2rem;
        line-height: 1.8rem;
        color: #333333;
    }

    .gotoUploadBtn {
        width: 80%;
        position: absolute;
        top: 60%;
        left: 50%;
        transform: translateX(-50%);
        background: #00706E;
        font-weight: 400;
        color: #FFFFFF;
        text-align: center;
        padding: 10px 0;
        font-size: 1.3rem;
        border-radius: 45px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/uploadUserPhoto/uploadFail.vue